import type { TTestimonialsElement } from '@shared/dream-components';
import { TestimonialsElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

interface Props {
  node: TTestimonialsElement;
  children: ReactNode | ReactNode[];
}

const Testimonials = ({ node, children }: Props) => {
  return <TestimonialsElement element={node}>{children}</TestimonialsElement>;
};

export default Testimonials;
